<template>
  <section
    id="topDiv"
    class="container-fluid d-flex flex-column px-0 mb-6"
  >
    <div class="container pb-5 pb-md-0">
      <div class="row">
        <div class="col-2 my-auto">
          <v-icon
            icon="chevron-left"
            class="cursor-pointer"
            @click="() => $router.back()"
          />
        </div>
        <div class="col-8 d-flex flex-column">
          <div class="h3 text-center">
            Déclarations de l'assuré
          </div>
        </div>
        <div class="col-12 col-md-8 mx-auto">
          <div class="text-center mb-2 mb-md-5">
            N° {{ current.reference }}
          </div>
        </div>
        <div class="col-12 col-md-10 mx-auto">
          <div class="h5 mb-3">
            Déclarations pour la couverture {{ productName }}
          </div>
          <div class="card shadow">
            <div class="card-body">
              <div class="d-flex flex-column list-decoration-pink">
                <template v-if="!isLoading">
                  <div
                    v-for="(elem, iter) in declarations"
                    :key="elem.id || iter"
                  >
                    <p
                      href="#"
                      class="flex-column align-items-start p-md-3"
                      style="cursor: text; border-radius:20px"
                      v-html="elem.mention"
                    />
                  </div>
                </template>
                <template v-else>
                  <v-placeholder />
                  <v-placeholder />
                  <v-placeholder />
                  <v-placeholder />
                </template>
              </div>
            </div>
          </div>
          <v-loader
            :next="routing"
            title="J\'accepte les déclarations"
            class="mx-auto w-100 mt-3"
          >
            <div class="d-flex flex-row mx-auto">
              <div class="ms-auto me-1">
                Accepter
              </div>
              <v-icon
                icon="arrow-white-right"
                class="me-auto"
              />
            </div>
          </v-loader>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { ui } from '@/mixins';

import PHDeclaration from '@/components/placeholder/declarations/PHDeclarations.vue';

export default {
  name: 'DeclarationView',
  components: {
    'v-placeholder': PHDeclaration,
  },
  mixins: [ui],
  beforeRouteLeave(to, from, next) {
    const paths = [
      `/client/contracts/${this.$route.params.id}`,
    ];
    if (!paths.includes(to.path)) {
      this.ui_showMenu(true);
    }
    next();
  },
  data() {
    return {
      declarations: [],
      error: false,
      isLoading: true,
      debouncer: ({ cancel: () => {} }),
    };
  },
  computed: {
    ...mapGetters({
      products: 'rater/products',
      current: 'contract/get',
    }),
    productName() {
      const { productId } = this.current;
      return (this.products.find(({ id }) => productId === id) || { name: 'Votre contrat' })
        .name;
    },
  },
  created() {
    this.$store.dispatch('rater/getDeclarations', this.$route.params.id)
      .then(({ data: declarations }) => { this.declarations = declarations })
      .catch(() => {})
      .finally(() => {
        this.ui_showPlaceholder();
      });
  },
  methods: {
    setErrorDeclaration() {
      this.error = true;
    },
    async routing() {
      await this.$store.dispatch('contract/validateSubscriptionDeclaration');
      if (this.current.plan === 'ANNUAL') {
        return this.$router.push('/client/contracts/confirmation?type=annual');
      }
      if (this.current.plan === 'MONTHLY') {
        return this.$router.push('/client/contracts/confirmation?type=monthly');
      }
      return this.$router.push('/client/contracts/confirmation');
    },
  },
};
</script>
<style scoped>
.not-clickable {
  pointer-events: none;
}
.clickable {
  pointer-events: auto;
}
</style>
